import { ContentContainer } from '../../components/common/ContentContainer/contentContainer';
import { Flex, Grid, Heading, Text, Box } from '@chakra-ui/react';
import { PageDescription } from 'src/components/common/PageDescription/pageDescription';
import { CartridgeForm } from '../../components/common/CartridgeForm/cartridgeForm';
import { useTranslation } from 'react-i18next';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { colors } from '../../utils/colors';
import { useState } from 'react';
import { ProgressBar } from '../../components/common/ProgressBar/progressBar';
import { Color } from 'src/theme/color';

export const Add = () => {
	const { t } = useTranslation();

	const { isChainValid } = useBlockchainProvider();

	return (
		// desktop
		<>
			<Grid
				position="relative"
				display={{ base: 'none', lg: 'grid' }}
			>
				{isChainValid ? (
					<CartridgeForm />
				) : (
					<ContentContainer>
						<Flex
							align="center"
							w="100%"
							mt="80px"
							flexDir="column"
							opacity="0.5"
						>
							<Heading>Network unavailable</Heading>
							<Text>Switch your wallet network</Text>
						</Flex>
					</ContentContainer>
				)}
			</Grid>

			<ContentContainer>
				<Flex
					display={{ base: 'flex', lg: 'none' }}
					w="100vw"
					justifyContent="center"
					alignItems="center"
					textTransform="uppercase"
				>
					<Text
						fontFamily="Sora"
						fontSize="25px"
					>
						{t('pages.addGame.mobile')}
					</Text>
				</Flex>
			</ContentContainer>
		</>
	);
};
